import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-link",
  "use": "icon-link-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-link\"><path d=\"M924.402 1023.068H.68V99.345h461.86v98.91H99.597V924.15h725.896V561.207h98.91z\" /><path d=\"m930.805 22.977 69.966 69.966-453.493 453.492-69.965-69.901z\" /><path d=\"M1022.464 304.03h-98.917V99.345H709.231V.428h313.233z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol